import React, { useCallback } from 'react';

import { useNotificationAnalytics } from 'hooks/analytics/useNotificationAnalytics';

import { UserAvatar } from 'components/shared/UserAvatar';

import css from './messageToast.module.sass';

export interface MessageToastContent {
  photo: string;
  name: string;
  message: string;
  onClick?: () => void;
}

export interface MessageToastProps {
  content: MessageToastContent;
  libOptions?: {
    autoClose?: number;
    closeButton?: boolean;
  };
}

export const MessageToast: React.FC<MessageToastContent> = ({
  photo,
  name,
  message,
  onClick,
}) => {
  const { trackClickOnNotification } = useNotificationAnalytics();

  const handleClick = useCallback(() => {
    if (!onClick) return;

    trackClickOnNotification();
    onClick();
  }, [onClick, trackClickOnNotification]);

  return (
    <div className={css.root} onClick={handleClick}>
      <UserAvatar url={photo} size="50px" />

      <p className={css.content}>
        <p className={css.title}>{name}</p>
        <p className={css.subtitle}>{message}</p>
      </p>
    </div>
  );
};
